// src/utils/permissions.ts

// 🚨 1. 프론트엔드의 자물쇠 이름 -> DB 스위치 이름(우리가 아까 만든 7대장) 연결표
export const PERMISSION_MAP: Record<string, string> = {
  'contacts_edit': 'edit_company_contact', // 고객관리 수정
  'sales_target_edit': 'edit_sales_target', // 매출목표 수정
  'forecast_edit': 'edit_forecast',         // 매출관리 수정
  // 아래는 향후 화면에 자물쇠 달 때 쓸 이름들입니다.
  'pipeline_edit': 'edit_pipeline',         // 영업진행상황 수정
  'lost_edit': 'edit_lost_account',         // 이탈거래처 수정
  'cs_edit': 'edit_cs',                     // CS팀 활동 수정
  'wbs_edit': 'edit_wbs',                   // WBS 수정
};

// 🚨 2. 스마트 권한 판독 로직
export const hasPermission = (user: any, action: string): boolean => {
  // 1. 유저 정보가 아예 없으면 무조건 차단
  if (!user) return false;

  // 2. 최고 관리자(admin)는 스위치 볼 필요도 없이 '무조건 프리패스(true)'!
  if (user.role === 'admin') return true;

  // 3. 만약 요청한 action이 "수정/삭제 권한(PERMISSION_MAP에 있는 놈)"이라면?
  const dbSwitchKey = PERMISSION_MAP[action];
  if (dbSwitchKey) {
    // 유저가 가진 권한 스위치(permissions) 꾸러미에서 해당 스위치가 켜져(true) 있는지 확인!
    // 스위치 꾸러미가 아예 없으면 기본값인 false 반환
    return user.permissions ? !!user.permissions[dbSwitchKey] : false;
  }

  // 4. "수정/삭제"가 아닌 단순 화면 진입(dashboard, pipeline 보기 등)은 기본적으로 모두 열어줌!
  return true;
};